export default {
  gamesPlayed: 0,
  totalCoryat: 0,
  totalPossibleCoryat: 0,
  totalRevealedCoryat: 0,
  totalPassedCoryat: 0,
  totalCorrect: 0,
  totalIncorrect: 0,
  totalRevealed: 0,
  totalPassed: 0,
  fjCorrect: 0, // final jeopardy
  fjIncorrect: 0,
  fjRevealed: 0,
  fjPassed: 0,
  totalLiveCoryat: 0, // this tracks the coryat scores of the 3 real contestants
};
